import { apiFetch } from '@/api'
import { Client } from '@/interfaces'

export const fetchAllClients = async (): Promise<Client> => (await apiFetch('/clients', { method: 'GET' })).data
